import { render, staticRenderFns } from "./link-item.vue?vue&type=template&id=ed8417d2&scoped=true"
import script from "./link-item.vue?vue&type=script&lang=js"
export * from "./link-item.vue?vue&type=script&lang=js"
import style0 from "./link-item.vue?vue&type=style&index=0&id=ed8417d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8417d2",
  null
  
)

export default component.exports